<template>
  <div>
    <section v-if="error">
      <error-alert :error="error" />
    </section>
    <div class="panel panel-primary">
      <div class="panel-heading PanelHeadingCaption roundedcornerdiv">
        Restricted Address Request
      </div>
      <div class="row Q_Row row-eq-height">
        <div class="col-sm-12 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label"
              >As defined by
              <a
                href="https://iga.in.gov/laws/2025/ic/titles/36#36-1-8.5-2"
                target="_blank"
                >Indiana Code 36-1-8.5-2</a
              >, the <em>Covered Person</em> is:</label
            >
            <div class="pl-5">
              <div
                class="form-check"
                v-for="(cp, i) in coveredPersons"
                :key="i"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="coveredPerson"
                  :value="cp"
                  v-model="
                    $v.RestrictedAddressQuestionnaire.CoveredPersonIs.$model
                  "
                />
                <label class="form-check-label">
                  {{ cp }}
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row Q_Row row-eq-height">
        <div class="col-sm-12 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label"
              >What is the full name of the <em>Covered Person</em>?</label
            >
            <input
              class="form-control form-control-lg"
              :class="{
                'is-invalid':
                  $v.RestrictedAddressQuestionnaire.CoveredPersonName
                    .$invalid && this.RestrictedAddressQuestionnaire.Submitted
              }"
              style="vertical-align: bottom !important"
              type="text"
              v-model="
                $v.RestrictedAddressQuestionnaire.CoveredPersonName.$model
              "
              maxlength="30"
              placeholder
            />
            <div class="invalid-feedback">
              Required!
            </div>
          </fieldset>
        </div>

        <div class="col-sm-12 row-flex">
          <fieldset class="form-group col-flex">
            <label class="Questionniare_Label"
              ><em>Covered Person</em>'s Job Title/Department/Office</label
            >
            <input
              class="form-control form-control-lg"
              :class="{
                'is-invalid':
                  $v.RestrictedAddressQuestionnaire.JobTitleDepartmentOffice
                    .$invalid && this.RestrictedAddressQuestionnaire.Submitted
              }"
              style="vertical-align: bottom !important"
              type="text"
              v-model="
                $v.RestrictedAddressQuestionnaire.JobTitleDepartmentOffice
                  .$model
              "
              maxlength="30"
              placeholder
            />
            <div class="invalid-feedback">
              Required!
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ErrorAlert from "../components/ErrorAlert.vue";

export default {
  components: { ErrorAlert },
  data: () => ({
    error: "",
    coveredPersons: [
      "(1) A judge.",
      "(2) A law enforcement officer.",
      "(3) An address confidentiality program participant.",
      "(4) A public official.",
      "(5) The surviving spouse of a person described in subdivision (2), if the person was killed in the line of duty.",
      "(6) An employee of the department of child services.",
      "(7) A current or former probation officer.",
      "(8) A current or former community corrections officer.",
      "(9) A regular, paid firefighter or a volunteer firefighter (as defined in IC 36-8-12-2).",
      "(10) A correctional services provider.",
      "(11) A public defender.",
      "(12) Any person who resides in the same household as a person described in this section."
    ]
  }),
  props: {
    CorpCode: {
      type: String,
      required: true
    },
    RestrictedAddressQuestionnaire: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    }
  },
  validations: {
    RestrictedAddressQuestionnaire: {
      CoveredPersonIs: {
        required
      },
      CoveredPersonName: {
        required
      },
      JobTitleDepartmentOffice: {
        required
      }
    }
  }
};
</script>
